import { Paragraph } from '@swordhealth/ui-corporate';
import styled, { css } from 'styled-components';

export const Wrapper = styled.section`
  background: linear-gradient(110.16deg, #eef4fd 22.27%, #fff2f3 68.93%);
  color: var(--ui-colors-grey-800);
  border-bottom: 1px solid var(--ui-colors-grey-light);
  padding: 12px 0;
  text-align: center;

  a {
    color: var(--ui-colors-grey-800) !important;
  }

  ${(props) =>
    props.$gradient &&
    css`
      background: linear-gradient(91.26deg, #5993ea 0.63%, #ff8283 98.97%);
      color: var(--ui-colors-white);
      padding: 4px 0;
      border-bottom: unset;
      a {
        color: var(--ui-colors-white) !important;
      }
    `};
  @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
    padding: 8px 0;
  }
`;

export const Inner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const CustomParagraph = styled(Paragraph)`
  width: 100%;
  text-wrap: balance;
  @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
    font-size: 14px;
  }
  ${(props) =>
    !props.$gradient &&
    css`
      font-size: 14px;
      line-height: 24px;
    `};
`;
export const Button = styled.button`
  cursor: pointer;
  width: 20px;
  height: 20px;

  ${(props) =>
    props.$gradient &&
    css`
      svg {
        width: 20px;
        height: 20px;
        path {
          fill: var(--ui-colors-white);
        }
      }
    `};
`;
